import React from 'react'

import {
  DateField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RowProfileField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  profile: { id: 'profile', label: 'Driver', renderer: LinkedField(RowProfileField) },
  dlStateCode: { id: 'dlStateCode', label: 'Drivers License State', renderer: ValueField },
  dlExpiresOn: { id: 'dlExpiresOn', label: 'Drivers License Expires On', renderer: DateField },
}

export const DriverListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Drivers"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
